import { Modal, SubmitButton } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import pluralize from "pluralize";
import React, { ReactNode, useState } from "react";

interface ToggleVariantStatusModalProps {
    isOpen: boolean;
    selectedCount: number;
    onClose: () => void;
    onApply: () => Promise<void> | void;
    action?: "unpublish" | "publish";
    title?: string;
    description?: ReactNode;
}

export const ToggleVariantStatusModal = ({
    isOpen,
    selectedCount,
    onClose,
    onApply,
    action = "unpublish",
    title,
    description,
}: ToggleVariantStatusModalProps) => {
    const isUnpublish = action === "unpublish";
    const [isSubmitting, setIsSubmitting] = useState(false);
    const modalTitle = title ?? (isUnpublish ? "Unpublish Selected Variants?" : "Publish Selected Variants?");
    const countLabel = (
        <strong>
            {selectedCount} selected {pluralize("variant", selectedCount)}
        </strong>
    );
    const modalDescription =
        description ??
        (isUnpublish ? (
            <>This will make {countLabel} hidden on the make a purchase screen and from checkout.</>
        ) : (
            <>This will make {countLabel} visible on the make a purchase screen and from checkout.</>
        ));

    const handleApply = async () => {
        if (isSubmitting) {
            return;
        }

        try {
            setIsSubmitting(true);
            await onApply();
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} size="small" onClose={onClose}>
            <Modal.Header onClose={onClose}>{modalTitle}</Modal.Header>
            <Modal.Body className="text-center">{modalDescription}</Modal.Body>
            <Modal.Footer className="justify-center">
                <SecondaryButton disabled={isSubmitting} onClick={onClose}>
                    Cancel
                </SecondaryButton>
                <SubmitButton type="button" isLoading={isSubmitting} onClick={handleApply}>
                    Apply
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
